import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { customFilterListModel, CustomGridFiltering, CustomGridSorting, RowCountResponse } from './custom-grid';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomGridSService {

  //**********************************************TO DO RIMUOVI */
  //apiUrl = 'http://192.168.1.254:7142';
  //apiUrl = '';
  apiUrl = environment.apiUrl.slice(0, -4);

  constructor(
    private http: HttpClient
  ) {

  }

  countRows(url: string, table: string, filters?: CustomGridFiltering[]): Observable<any> {
    url = `${this.apiUrl}${url}${table}?`;

    // aggiunge filtri
    if (filters != undefined) {
      if (filters.length > 0) {
        filters.forEach(f => {
          if (f.field !== "" && f.field !== undefined && f.field !== null) {
            if (f.value.length > 0) {
              console.warn("service get rows");
              console.warn(f.field);
              console.warn(f.value);
              url = url + `&${f.field}=${f.value}`;
              console.warn(url);
            }
          }
        });
      }
    }

    return this.http.get<any>(url);
  }

  getLazyData(url: string, offset: number, max: number, filters?: customFilterListModel[], sort?: CustomGridSorting[]): Observable<any> {
    url = this.apiUrl + url + `/${offset}/${max}?`;
    

    // Aggiunge filtri
    if (filters != undefined) {
      if (filters.length > 0) {
        filters.forEach(f => {
          if(f.filterValue != undefined){
            if(f.filterValue != "") {
              url = url + `&${f.field}=${f.filterValue}`;
            }            
          }
          
        });
      }
    }

    // Aggiunge ordinamento
    if (sort != undefined) {
      if (sort.length > 0) {
        sort.forEach(s => {
          url = url + `&orderby=${s.field}`;
          url = url + `&direction=${s.direction}`;
        });
      }
    }

    return this.http.get(url);
  }

  getDataNoLazy(url: string, filters?: customFilterListModel[], sort?: CustomGridSorting[]): Observable<any> {
    url = this.apiUrl + url + `?`;
    

    // Aggiunge filtri
    if (filters != undefined) {
      if (filters.length > 0) {
        filters.forEach(f => {
          if(f.filterValue != undefined){
            if(f.filterValue != "") {
              url = url + `&${f.field}=${f.filterValue}`;
            }            
          }
          
        });
      }
    }

    // Aggiunge ordinamento
    if (sort != undefined) {
      if (sort.length > 0) {
        sort.forEach(s => {
          url = url + `&orderby=${s.field}`;
          url = url + `&direction=${s.direction}`;
        });
      }
    }

    return this.http.get(url);
  }


  getLazyDataWithArg(url: string, offset: number, max: number, filters?: CustomGridFiltering[], sort?: CustomGridSorting[], arg?: string, parent?: string): Observable<any> {
    url = this.apiUrl + url + `/${offset}/${max}?`;

    if (arg && parent) {
      url += `&dataType=${arg}&parent=${parent}`;
    }
    // Aggiunge filtri
    if (filters != undefined) {
      if (filters.length > 0) {
        filters.forEach(f => {
          url = url + `&${f.field}=${f.value}`;
        });
      }
    }

    // Aggiunge ordinamento
    if (sort != undefined) {
      if (sort.length > 0) {
        sort.forEach(s => {
          url = url + `&orderby=${s.field}`;
          url = url + `&direction=${s.direction}`;
        });
      }
    }

    return this.http.get(url);
  }

  getAllData(url: string): Observable<any> {
    url = this.apiUrl + url;
    return this.http.get(url);
  }

}
